import { render, staticRenderFns } from "./signatureList.vue?vue&type=template&id=1dc83bc4&scoped=true&"
import script from "./signatureList.vue?vue&type=script&lang=js&"
export * from "./signatureList.vue?vue&type=script&lang=js&"
import style0 from "./signatureList.vue?vue&type=style&index=0&id=1dc83bc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc83bc4",
  null
  
)

export default component.exports